function initializeProductCardSwipers() {
  if (window.productCardSwipers && Array.isArray(window.productCardSwipers)) {
    window.productCardSwipers.forEach(obj => {
      if (obj.swiper && typeof obj.swiper.destroy === 'function') {
        obj.swiper.destroy(true, true);
      }
    });
  }

  window.productCardSwipers = [];
  document.querySelectorAll('[data-product-card-slider]').forEach(function (sliderEl) {
    const swiperInstance = new Swiper(sliderEl, {
      loop: false,
      pagination: {
        nested: true,
        touchStartPreventDefault: false,
        allowTouchMove: true,
        el: sliderEl.querySelector('[data-swiper-progress-bar]'),
        type: 'progressbar',
      },
    });

    window.productCardSwipers.push({
      id: sliderEl.getAttribute('data-product-id'),
      swiper: swiperInstance,
      el: sliderEl
    });
  });

  document.querySelectorAll('[data-color-img]').forEach(function (labelEl) {
    labelEl.addEventListener('click', function () {
      const targetColor = labelEl.getAttribute('data-color-img');
      const productId = labelEl.getAttribute('data-product-id');
      const swiperObj = window.productCardSwipers.find(obj => obj.id === productId);
      if (!swiperObj) return;
      const { swiper, el } = swiperObj;
      const slides = el.querySelectorAll('[data-swiper-slide]');
      slides.forEach((slide, index) => {
        if (slide.getAttribute('data-color') === targetColor) {
          swiper.slideToLoop(index);
        }
      });
    });
  });
}

let isolated = false;
const recommendationsInterval = setInterval(function () {
  const cardsExist = document.querySelectorAll('[data-recommendations-carousel] [data-product-card]').length > 0;
  if (cardsExist && !isolated) {
    isolated = true;
    const mainContainers = document.querySelectorAll('[data-recommendations-main]');
    mainContainers.forEach((container) => {
      if (container.getAttribute('data-swiper-initialized') === 'true') return;
      const swiperContainer = container.querySelector('[data-recommendations-container]');
      const slidesPerViewDesktop = parseFloat(swiperContainer.getAttribute('data-slides-per-view'));
      const slidesPerViewMobile = parseFloat(swiperContainer.getAttribute('data-slides-per-view-mobile'));
      const scrollbarEl = container.querySelector('[data-recommendations-scrollbar]');
      new Swiper(swiperContainer, {
        slidesPerView: slidesPerViewDesktop,
        loop: false,
        simulateTouch: true,
        touchStartPreventDefault: false,
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false
        },
        breakpoints: {
          0: {
            slidesPerView: slidesPerViewMobile + 0.9,
            spaceBetween: 12
          },
          768: {
            slidesPerView: slidesPerViewDesktop,
            spaceBetween: 0
          }
        },
        on: {
          touchStart(swiper, event) {
            const isExcluded = event.target.closest('[data-product-card-swiper-active]');
            const isClickable = event.target.closest('[data-product-card-title]');
            if (!isExcluded && !isClickable) {
              swiper.allowTouchMove = true;
            } else {
              swiper.allowTouchMove = false;
            }
          },
          touchEnd(swiper) {
            swiper.allowTouchMove = false;
          }
        }
      });
      container.setAttribute('data-swiper-initialized', 'true');
    });
    initializeProductCardSwipers();
    clearInterval(recentlyViewedInterval);
  } else if (!cardsExist && isolated) {
    isolated = false;
  }
}, 500);
